<template>
  <div class="content__item">
    <div class="content__top mobile_only" style="flex-direction: column;width: 100%;">
      <div class="content__resource">
        <a :href="content.link" target="_blank">
          <img :src="`https://favicon.yandex.net/favicon/v2/${content.link}?size=16&stub=1`"
               :alt="content.title">
          <b>{{getDisplayedLink}}</b>
        </a>
      </div>
      <div class="mobile_only item_mobile_thumbnail" v-if="thumbnail_showed && getThumbnail">
        <img :src="getThumbnail" alt="" @error="thumbnail_showed=false">
      </div>
    </div>

    <div class="result__content">

      <div class="content__thumbnail desktop_only" v-if="getThumbnail">
        <div v-if="orientation === 'portrait'" :style="{'background-image':'url('+getThumbnail}"></div>
        <img v-if="orientation === 'landscape'" :src="getThumbnail" alt="">
      </div>

      <div class="content__wrapper">
        <div style="width: 100%">
          <div class="content__top desktop_only">
            <div class="content__favicon">
              <a :href="content.link" target="_blank">
                <img :src="`https://favicon.yandex.net/favicon/v2/${content.link}?size=16&stub=1`"
                     :alt="content.title">
              </a>
            </div>
            <span>
              <a :href="content.link" target="_blank">
                <b> {{getDisplayedLink}} </b>
              </a>
            </span>
          </div>
          <a class="content__link" :href="content.link" target="_blank"
             v-if="content.displayed__link">{{ content.displayed__link }}</a>
          <h2 class="content__title">
            <a :href="content.link" target="_blank">{{ getTitle }}</a>
          </h2>
          <div class="content__date" v-if="content.date">{{ content.date }}</div>
          <div class="content__desc" v-html="getSnippet"></div>
        </div>
        <div class="content__type">
          <div class="positions">
            <div class="position" v-for="(val, index) in getPositions" :key="index">
              <img style="height: 12px;" :src="icons_override[val.name] || `https://favicon.yandex.net/favicon/v2/${val.name}.com?size=16&stub=1`" :alt="content.title">
              <span>{{ val.pos }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img :src="this.thumbnail" class="dummy" ref="dummy_thumb" @error="thumbnail_showed=false" @load="onThumbnailLoaded">
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: "TypeSearch",
  props: ['content', 'positions','icons_override','thumbnail'],
  data() {
    return {
      thumbnail_showed: false,
      orientation: null,
    }
  },
  computed: {
    getDisplayedLink() {
      let link
      if (this.content.displayed_link) {
        link = this.content.displayed_link
      }
      else {
        link = this.content.link
      }
      if (link.indexOf('›') !== -1) {
        link = link.split('›')[0]
      }
      if (link.indexOf('http') !== -1) {
        link = link.split('/')[2]
      }
      // убираем www.
      link = link.replace("www.","");
      // убираем домен
      {
        const match = link.match(/(.+)\.(\w+)/);
        if(match && match[2].length <= 3) {
          link = match[1];
        }
      }

      return link
    },
    getPositions() {
      let arr = []
      for (let position of this.content.positions) {
        const find = _.find(arr, (item) => {
          return item.name === position.name
        })
        if (!find) {
          arr.push(position)
        }
      }
      arr = _.sortBy(arr,'pos')
      return arr
    },
    getSnippet(){
      if(this.content.snippet){
        let snippet = this.content.snippet;
        snippet = snippet.replace("...","");
        snippet = snippet.replace("…","");
        return snippet;
      }
      return this.content.snippet;
    },
    getTitle(){
      let title = this.content.title;
      title = title.replace("...","");
      title = title.replace("…","");
      return title;
    },
    getThumbnail(){
      return this.thumbnail_showed ? this.thumbnail : null;
    },
  },
  methods: {
    onThumbnailLoaded(){
      const img = this.$refs.dummy_thumb;
      if(img) {
        this.orientation = img.width / img.height >= 2 ? "landscape" : "portrait";
        this.thumbnail_showed = img.width > 50 && img.height > 50;
      }
    }
  },
}
</script>

<style scoped lang="scss">

.result__content{
  display: flex;
  width: 100%;
}

.content__wrapper{
  flex-direction: column;
  width: 100%;
  align-items: stretch;
  display: flex;
  justify-content: space-between;
}

.content__item {
  display: flex;
  flex-direction: column;
}

.positions{
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.position{
  background: #f3f5ff;
  padding: 5px 8px;
  border-radius: 10px;
  margin: 3px;
  height: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  text-align: center;
}

.position span{
  margin-left: 3px;
  vertical-align: middle;
  font-size: 14px;
}

.content__desc{
  font-size: 0.8em;
}

.content__thumbnail{
  width: 50%;
  display: flex;
  align-items: center;
  margin-right: 10px;
  max-height: 230px;
  overflow: hidden;
  border-radius: 5px;
}

.content__thumbnail img{
  width: 100%;
  border-radius: 5px;
}

.content__thumbnail div {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
}

.item_mobile_thumbnail{
  overflow: hidden;
  max-height: 180px;
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0;
  border: 2px solid #e4e4f9;
}

.item_mobile_thumbnail img{
  border-radius: 10px;
  height: 180px;
  object-fit: contain;
}

img.dummy{
  display: none;
}

.content__item {
  width: 100%;
  border-radius: 15px;
  padding: 5px;
  text-align: left;
  box-shadow: 0px 4px 12px 0px #0d234308;
  margin-bottom: 5px;
  background-color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 768px) {
    padding: 10px;
  }
}

.content__resource {
  display: flex;
  align-self: flex-start;
  align-items: center;

  a {
    display: flex;
    align-items: center;
  }

  img {
    vertical-align: unset !important;
    height: 22px;
    border-radius: 7px;
    border: 2px solid #e4e4f9;
  }

  b {
    font-size: 16px;
    margin-left: 10px;
  }
}

</style>